import React from 'react';

const IntegrationLogFormModal = React.lazy(() => import('../components/FormModal'));
const integrationLogModalRegistry = {
    core_integrationLogId: IntegrationLogFormModal
};
export default integrationLogModalRegistry;
